import { Controller } from "@hotwired/stimulus";
import { humanFileSize, addFile } from "../utils/files";

export default class extends Controller {
  static targets = ["template", "gallery", "input", "unpersisted", "gallerySection"];
  static classes = ["supportedInput"];

  connect() {
    this.inputTarget.classList.add(...this.supportedInputClasses);
    this.fileArray = [];
  }

  addToGallery({ detail: { file } }) {
    addFile({ newFile: file, existingFiles: this.fileArray });

    this.unpersistedTargets.forEach((n) => n.remove());
    this.gallerySectionTarget.classList.remove("hidden");

    this.fileArray.forEach((file) => {
      this.#addFile(file);
    });
  }

  removeFile(event) {
    const target = this.unpersistedTargets.find((li) => li.contains(event.currentTarget));
    const fileName = target.querySelector('[data-target="name"]').title;
    this.fileArray = this.fileArray.filter(file => file.name !== fileName);

    this.dispatch("removed", { detail: { fileName } });
    target.remove();

    if (this.unpersistedTargets.length === 0) {
      this.gallerySectionTarget.classList.add("hidden");
    }
  }

  #addFile(file) {
    const clone = this.templateTarget.content.cloneNode(true);
    const nameElement = clone.querySelector("[data-target='name']");
    const sizeElement = clone.querySelector("[data-target='size']");

    nameElement.textContent = file.name;
    nameElement.title = file.name;
    sizeElement.textContent = humanFileSize(file.size);

    if(file.type.startsWith("image/")) {
      const objectURL = URL.createObjectURL(file);
      Object.assign(clone.querySelector("img"), {
        src: objectURL,
        alt: file.name,
      });
    }

    this.galleryTarget.append(clone);
  }
}
